/**
 * @description 支付宝微信二码合一支付页面。
 */
import React, { FC, useEffect } from 'react'
import { IonContent, IonPage, IonSpinner } from '@ionic/react'
import { trace, toDecimal, sleep } from '@dt/fe-utils'
import { alertLayer, getPlatform } from '@utils'
import { memberMobx } from '@mobx/mkt'
import authHandle from '@common/init/authHandle'
import { payChannelMobx, payMobx } from '@mobxStore'
import { TPayScene } from '@mobx/pay/pay.mobx'
import { apConfigG } from '@ctrls/third'
import { orderMobx } from 'restaurant'
import { observer } from 'mobx-react'
import { useParams } from 'react-router-dom'

import './MergeQr.scss'
/**
 * 支付宝微信二码合一扫码
 */
interface IProps {}
const MergeQrV2: FC<IProps> = () => {
  const { BRANDID } = Config
  const query = new URLSearchParams(location.search)
  function closeWindow () {
    const { isWeixinBrower, isAlipay } = getPlatform()
    if (isAlipay) {
      apConfigG.close()
    } else if (isWeixinBrower) {
      window.WeixinJSBridge.invoke('closeWindow')
    }
  }
  function invokePay (result: any) {
    const { isWeixinBrower, isAlipay } = getPlatform()
    return new Promise((resolve, reject) => {
      if (result.wapPayRequest) {
        if (isAlipay) {
          const { wapPayRequest } = result
          const { tradeNo } = wapPayRequest
          if (tradeNo) {
            // apConfigG.init(() => {
            apConfigG.pay(tradeNo, function (resultCode) {
              if (resultCode === '9000') {
                resolve(undefined)
                closeWindow()
              } else {
                reject(new Error('支付宝支付错误'))
              }
            })
            // })
          } else if (wapPayRequest.code) {
            throw Error(wapPayRequest.subMsg)
          }
        } else if (isWeixinBrower) {
          window.WeixinJSBridge.invoke('getBrandWCPayRequest', result.wapPayRequest, function (res) {
            if (res.err_msg !== 'get_brand_wcpay_request:ok') {
              reject(new Error(i18n.t('pay.payError.wechatScan')))
              trace.traceLog({
                name: '支付: => C扫B微信支付失败V2',
                message: { error: res, parmas: result.wapPayRequest }
              })
            }
            resolve(undefined)
          })
        }
      }
    })
  }
  async function startPay (ordersId, amount) {
    try {
      return await orderMobx.startPay(ordersId, amount)
    } catch (e) {
      return {}
    }
  }
  async function doPay () {
    console.log('doPay方法调用，如果调用两次，就是有问题')
    const obj = JSON.parse(memberMobx.thirdAuthInfo) || {}
    if (!obj.gOpenId) {
      const locNeedOpenId = localStorage.getItem(`ls.needOpenId.flag.${BRANDID}`)
      const locGOpenId = locNeedOpenId ? localStorage.getItem(`ls.needOpenId.gOpenId.${BRANDID}`) : null
      obj.gOpenId = query.get('gopenId') || query.get('gopenid') || locGOpenId
      if (!obj.gOpenId) {
        const result = await payMobx.fetchGOpenIdAndSave()
        obj.gOpenId = result.openId
        if (!obj.gOpenId) {
          await authHandle()
          return
        }
      }
    }
    if (paramSign) {
      try {
        const paramStr = atob(paramSign)
        const reqParam = JSON.parse(paramStr)
        const { scene, ordersId, amount } = reqParam
        payChannelMobx.changeScene(scene)
        const { isWeixinBrower, isAlipay } = getPlatform()
        const payMethod = payChannelMobx.availableExternalMethods.find(e => e === 'AlipayApp' || e === 'WechatPayWeb')
        if (payMethod === undefined) {
          await alertLayer(i18n.t('pay.noPayEnv'))
          closeWindow()
        }
        if (payMethod) {
          const payChannel = payChannelMobx.methodChannel[payMethod]
          let channelExt
          if (isAlipay) {
            channelExt = { buyerId: obj.gOpenId }
          } else if (isWeixinBrower) {
            channelExt = { openId: obj.gOpenId }
          }
          // const prepayCreate: any = await startPay(ordersId, amount)
          await payMobx.init({ scene: scene as TPayScene, orderId: ordersId, noOtherConfig: true, pcid: null })
          const result: any = await payMobx.pay({ amount: toDecimal(amount, 2) as any, ordersId, tip: 0, channel: payChannel.channelType, channelExt })
          await invokePay(result)
        }
      } catch (e) {
        await alertLayer(e.message)
        closeWindow()
      }
    } else {
      await alertLayer(i18n.t('pay.qrcodeRetry'))
      closeWindow()
    }
    payChannelMobx.changeScene()
  }

  const { paramSign } = useParams<{paramSign: string}>()
  useEffect(() => {
    console.log('bin.hu: to do 修正：第一次调用，但是payChannelMobx.availableExternalMethods 不知道有没有获取', `payChannelMobx.channels: ${payChannelMobx.channels.length}`)
    const $sleep = sleep(() => {
      return payChannelMobx.channels.length !== 0
    }, 300)
    $sleep(() => {
      console.log('确定调用了，如果这个调用两次就有问题', `payChannelMobx.channels: ${payChannelMobx.channels.length}`)
      doPay()
    })
  }, [])
  // useEffect(() => {
  //   console.log('第一次调用，但是payChannelMobx.availableExternalMethods 不知道有没有获取', `payChannelMobx.channels: ${payChannelMobx.channels.length}`)
  //   if (payChannelMobx.channels.length !== 0) {
  //     console.log('确定调用了，如果这个调用两次就有问题', `payChannelMobx.channels: ${payChannelMobx.channels.length}`)
  //     doPay()
  //   }
  // }, [payChannelMobx.availableExternalMethods])
  return (
    <IonPage>
      <IonContent>
        <div className='mergeqr-content'>
          <IonSpinner></IonSpinner>
        </div>
      </IonContent>
    </IonPage>
  )
}
export default observer(MergeQrV2)
